/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { BasePartyViewModel } from './BasePartyViewModel';
import {
    BasePartyViewModelFromJSON,
    BasePartyViewModelFromJSONTyped,
    BasePartyViewModelToJSON,
} from './BasePartyViewModel';
import type { ResultStates } from './ResultStates';
import {
    ResultStatesFromJSON,
    ResultStatesFromJSONTyped,
    ResultStatesToJSON,
} from './ResultStates';

/**
 * 
 * @export
 * @interface ResultOfIEnumerableOfBasePartyViewModel
 */
export interface ResultOfIEnumerableOfBasePartyViewModel {
    /**
     * 
     * @type {ResultStates}
     * @memberof ResultOfIEnumerableOfBasePartyViewModel
     */
    resultState: ResultStates;
    /**
     * 
     * @type {string}
     * @memberof ResultOfIEnumerableOfBasePartyViewModel
     */
    type?: string;
    /**
     * 
     * @type {number}
     * @memberof ResultOfIEnumerableOfBasePartyViewModel
     */
    status?: number;
    /**
     * 
     * @type {string}
     * @memberof ResultOfIEnumerableOfBasePartyViewModel
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof ResultOfIEnumerableOfBasePartyViewModel
     */
    detail?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResultOfIEnumerableOfBasePartyViewModel
     */
    errors: Array<string>;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ResultOfIEnumerableOfBasePartyViewModel
     */
    validationErrors: { [key: string]: Array<string>; };
    /**
     * 
     * @type {Array<BasePartyViewModel>}
     * @memberof ResultOfIEnumerableOfBasePartyViewModel
     */
    data?: Array<BasePartyViewModel>;
    /**
     * 
     * @type {number}
     * @memberof ResultOfIEnumerableOfBasePartyViewModel
     */
    count: number;
}

/**
 * Check if a given object implements the ResultOfIEnumerableOfBasePartyViewModel interface.
 */
export function instanceOfResultOfIEnumerableOfBasePartyViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "resultState" in value;
    isInstance = isInstance && "errors" in value;
    isInstance = isInstance && "validationErrors" in value;
    isInstance = isInstance && "count" in value;

    return isInstance;
}

export function ResultOfIEnumerableOfBasePartyViewModelFromJSON(json: any): ResultOfIEnumerableOfBasePartyViewModel {
    return ResultOfIEnumerableOfBasePartyViewModelFromJSONTyped(json, false);
}

export function ResultOfIEnumerableOfBasePartyViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultOfIEnumerableOfBasePartyViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'resultState': ResultStatesFromJSON(json['ResultState']),
        'type': !exists(json, 'Type') ? undefined : json['Type'],
        'status': !exists(json, 'Status') ? undefined : json['Status'],
        'title': !exists(json, 'Title') ? undefined : json['Title'],
        'detail': !exists(json, 'Detail') ? undefined : json['Detail'],
        'errors': json['Errors'],
        'validationErrors': json['ValidationErrors'],
        'data': !exists(json, 'Data') ? undefined : ((json['Data'] as Array<any>).map(BasePartyViewModelFromJSON)),
        'count': json['Count'],
    };
}

export function ResultOfIEnumerableOfBasePartyViewModelToJSON(value?: ResultOfIEnumerableOfBasePartyViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ResultState': ResultStatesToJSON(value.resultState),
        'Type': value.type,
        'Status': value.status,
        'Title': value.title,
        'Detail': value.detail,
        'Errors': value.errors,
        'ValidationErrors': value.validationErrors,
        'Data': value.data === undefined ? undefined : ((value.data as Array<any>).map(BasePartyViewModelToJSON)),
        'Count': value.count,
    };
}

